import React from "react";
import { Copy, Printer, Save, Palette, FileDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import ShareButtons from "@/components/ShareButtons";

const FIELDS = [
  { key: "customer", label: "Customer 客户", testid: "customer-name-input", placeholder: "Name" },
  { key: "phone", label: "Phone 电话", testid: "customer-phone-input", placeholder: "04xx", inputMode: "tel", cls: "font-mono-num" },
  { key: "plate", label: "Plate 车牌", testid: "plate-input", placeholder: "ABC123", cls: "font-mono-num uppercase" },
  { key: "vehicle", label: "Vehicle 车辆", testid: "vehicle-input", placeholder: "Make & model" },
];

export default function CustomerFields({ fields, setField, onCopy, onPrint, onPdf, onSave, saving, savedNo, getText, countryCode, onSharePdf, onBeforeShare }) {
  return (
    <div className="bg-[#151D2E] rounded-2xl border border-slate-800 p-5 space-y-3">
      <div className="grid grid-cols-2 gap-2">
        {FIELDS.map((f) => (
          <div key={f.key} className="space-y-1">
            <Label className="text-[11px] uppercase tracking-wider text-slate-400">{f.label}</Label>
            <Input value={fields[f.key]} onChange={(e) => setField(f.key, e.target.value)} data-testid={f.testid} inputMode={f.inputMode}
              className={`bg-slate-950/60 border-slate-700 h-9 text-sm ${f.cls || ""}`} placeholder={f.placeholder} />
          </div>
        ))}
        <div className="space-y-1 col-span-2">
          <Label className="text-[11px] uppercase tracking-wider text-slate-400 flex items-center gap-1"><Palette className="w-3 h-3 text-violet-300" /> Paint Code 色号</Label>
          <Input value={fields.paintCode} onChange={(e) => setField("paintCode", e.target.value)} data-testid="paint-code-input" className="bg-slate-950/60 border-slate-700 h-9 text-sm font-mono-num uppercase" placeholder="e.g. 1G3 / NH-731P" />
        </div>
      </div>
      <Button onClick={onSave} disabled={saving} data-testid="save-quote-btn" className="w-full h-11 bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold disabled:opacity-70"><Save className={`w-4 h-4 mr-2 ${saving ? "animate-pulse" : ""}`} />{saving ? "Saving…" : savedNo ? `Update quote ${savedNo}` : "Save quote · 保存报价"}</Button>
      <div className="grid grid-cols-3 gap-2">
        <Button onClick={onCopy} variant="outline" data-testid="copy-quote-summary-btn" className="border-slate-700 bg-slate-900/60 hover:bg-slate-800 text-slate-200"><Copy className="w-4 h-4 mr-1.5" />Copy</Button>
        <Button onClick={onPrint} variant="outline" data-testid="print-quote-pdf-btn" className="border-slate-700 bg-slate-900/60 hover:bg-slate-800 text-slate-200"><Printer className="w-4 h-4 mr-1.5" />Print</Button>
        <Button onClick={onPdf} data-testid="export-pdf-btn" className="bg-sky-700 hover:bg-sky-600 text-white font-bold"><FileDown className="w-4 h-4 mr-1.5" />PDF</Button>
      </div>
      <div className="flex gap-2 [&>button]:flex-1" data-testid="share-row">
        <ShareButtons getText={getText} phone={fields.phone} countryCode={countryCode} onSharePdf={onSharePdf} onBeforeShare={onBeforeShare} />
      </div>
    </div>
  );
}
